import GamblingRoutes from './gamblingRoutes'
import EcommRoutes from './ecommRoutes'
import GamblingPage from '@/pages/GamblingPage.vue'

const routes = [
  ...GamblingRoutes,
  ...EcommRoutes
]

export default routes
